import React, {useState} from 'react';
import { Grid,Paper, Avatar, TextField, Button, Typography,Link, Alert } from '@mui/material'
import { auth, db } from '../../firebase/firebase';
import { createUserWithEmailAndPassword } from 'firebase/auth';
import { addDoc, collection } from 'firebase/firestore';
import { useNavigate } from 'react-router-dom';
/* import AddCircleOutlinedIcon from '@mui/icons-material/AddCircleOutlined'; */


const RegisterScreen = () => {

    const paperStyle2 = { padding: 20, width: 300, margin: "200px auto" }
    const headerStyle = { margin: 10 }
    const avatarStyle2 = { backgroundColor: '#39aa28' }
    const btnstyle={margin:'8px 0'}
    const textStyle={margin:'4px 0'}

    const [email, setEmail] = useState('')
    const [password, setPassword] = useState('')
    const [secondPass, setsecondPass] = useState('')

    const [error, setError] = useState(null);

    const navigate = useNavigate();
    
    const procesarDatos = (e) =>{
        e.preventDefault();

        if(!email.trim()){
        setError('Ingresar email');
        return
        }

        if(!password.trim()){
        setError('Ingresar contraseña');
        return
        }

        if(password.length < 6){
        setError('Contraseña menor a 6 caracteres')
        return
        }

        if(password!=secondPass){
            setError('Contraseñas no coinciden')
            return
        }

        /* console.log('Pasando todas las validaciones'); */
        setError(null);
        registrarUsuario();
    }
    
    const registrarUsuario = async(e) =>{
        await createUserWithEmailAndPassword(auth, email, password)
            .then(async(userCredential) => {
                // Signed in
                const user = userCredential.user;
                const today = new Date();
                const now = today.toLocaleDateString();
                // ...
                await addDoc(collection(db, 'usuarios'), {
                    email: user.email,
                    uid: user.uid,
                    registro: now,
                    rol: 'usuario'
                })
                
                /* await addDoc(collection(db, user.uid), {
                    titulo: 'Diagrama de ejemplo',
                    fecha:  now
                }) */

                setEmail('')
                setPassword('')
                setsecondPass('')
                setError(null)
                navigate('/')

            })
            .catch((error) => {
                const errorCode = error.code;
                const errorMessage = error.message;
                /* console.log(errorCode)
                console.log(errorMessage) */
                
                if(errorCode==='auth/invalid-email'){
                    setError('Email no válido')
                }
                if(errorCode==='auth/email-already-in-use'){
                    setError('El correo ya está registrado')
                }
            });
    }

    return (
        <Grid>
            <Paper elevation={10} style={paperStyle2}>
                <Grid align='center'>
                    <Avatar style={avatarStyle2}>
                        {/* <AddCircleOutlinedIcon /> */}
                    </Avatar>
                    <h2 style={headerStyle}>Crear Cuenta</h2>
                    <Typography variant='caption' gutterBottom>
                        Rellena este formulario para tener una cuenta!
                    </Typography>
                </Grid>
                <form>
                    { 
                        error && (
                        <Alert severity="error" >{error}</Alert>
                        )
                    }
          
                   
                    <TextField 
                        style={textStyle} 
                        fullWidth 
                        label='Correo' 
                        placeholder="Ingresa tu correo" 
                        onChange={(e)=>{setEmail(e.target.value)}}
                        value={email}
                        required
                    />
                    <TextField 
                        style={textStyle} 
                        fullWidth label='Contraseña' 
                        placeholder="Ingresa tu contraseña"
                        type='password' 
                        onChange={(e)=>{setPassword(e.target.value)}}
                        value={password}
                        required
                    />
                    <TextField 
                        style={textStyle} 
                        fullWidth 
                        label='Confirmar contraseña' 
                        placeholder="Confirmar contraseña"
                        type='password' 
                        onChange={(e)=>{setsecondPass(e.target.value)}}
                        value={secondPass}
                        required
                    />

                    <Button 
                        type='submit' 
                        variant='contained' 
                        color='primary'
                        style={btnstyle}
                        onClick={procesarDatos}
                    >
                        Crear Cuenta
                    </Button>
                    <Typography > Ya tienes cuenta? 
                        <Link href="/login" >
                            Inicia sesión
                        </Link>
                    </Typography>
                </form>
            </Paper>
        </Grid>
    )
}

export default RegisterScreen